import { BKJCenteredDialog } from 'components/BKJCenteredDialog';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { DeleteAllOpenShiftsDialogProps } from 'pages/Settings/pages/LocationSettings/PositionsAllocation/DeleteAllOpenShiftsDialog/DeleteAllOpenShiftsDialog.types';
import {
  useDeleteAllOpenShiftsDialogFormProviderFormContext,
  DeleteAllOpenShiftsDialogFormProvider,
} from 'pages/Settings/pages/LocationSettings/PositionsAllocation/DeleteAllOpenShiftsDialog/DeleteAllOpenShiftsDialog.form.context';

const DeleteAllOpenShiftsDialogView: FC<DeleteAllOpenShiftsDialogProps> = ({
  isDeleteAllOpenShiftsConfirmationOpen,
  setIsDeleteAllOpenShiftsConfirmationOpen,
}) => {
  const { t } = useTranslation();
  const { handleAllOpenShifts } = useDeleteAllOpenShiftsDialogFormProviderFormContext();
  return (
    <BKJCenteredDialog
      isOpen={isDeleteAllOpenShiftsConfirmationOpen}
      variant="Danger"
      title={t('dialog:DELETE_ALL_SHIFTS')}
      text={t('dialog:DELETE_ALL_SHIFTS_WARNING')}
      cancelLabel={t('auth:BACK')}
      actionLabel={t('auth:CONFIRM')}
      onAction={() => {
        setIsDeleteAllOpenShiftsConfirmationOpen(false);
        return handleAllOpenShifts();
      }}
      onCancel={() => setIsDeleteAllOpenShiftsConfirmationOpen(false)}
      onClose={() => setIsDeleteAllOpenShiftsConfirmationOpen(false)}
    />
  );
};

export const DeleteAllOpenShiftsDialog: FC<DeleteAllOpenShiftsDialogProps> = (props) => {
  return (
    <DeleteAllOpenShiftsDialogFormProvider {...props}>
      <DeleteAllOpenShiftsDialogView {...props} />
    </DeleteAllOpenShiftsDialogFormProvider>
  );
};
